import React, { Component } from "react";
import { CsValidationContext } from "./csValidationForm";

class CsNonValidation extends Component {

  // Get context from csValidationForm
  static contextType = CsValidationContext;
  
  componentDidMount() {
    const {addValidator} = this.context;
    addValidator(this);
  }
  
  componentWillUnmount() {
    const {removeValidator} = this.context;
    removeValidator(this);
  }

  render() {
    let children = this.props.children;
    const { realtime, doValidatePrevEls } = this.context, additionalProps = {};

    return React.Children.map(children, child => {
      if (!child) {
        return '';
      }

      if (realtime && !child.props.onFocus) {
        additionalProps.onFocus = () => doValidatePrevEls(this);
      }

      return React.cloneElement(child, { ...additionalProps });
    });
  }
}

export default CsNonValidation;